import * as Sentry from "@sentry/angular";

const SENTRY_URL = process.env.SENTRY_URL;
const VERSION = process.env.npm_package_version || 'dev';

if (SENTRY_URL) {
    console.log('Sentry initialized!');
    Sentry.init({
        dsn: process.env.SENTRY_URL,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: 1, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        environment: location.hostname === 'localhost' ? 'development' : location.hostname.split('.')[0],
        // Enable source maps for better stack traces
        enableTracing: true,
        // Release tracking for source maps - IMPORTANTE: debe coincidir con la versión subida a Sentry
        release: VERSION,
        // Enable debug mode in development
        debug: location.hostname === 'localhost'
    });
    
    console.log('Sentry release version:', VERSION);
}
